import React from 'react'

import en from '@portal/i18n/data/en.json'

import type { I18n } from './types'

export const I18nContext = React.createContext<I18n>({ lang: 'en', i18n: en })
